module.exports = __webpack_public_path__ + "static/media/Tak.f316c6fe.PNG";